import React, { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

const FormatIForm = forwardRef(({ formData, setFormData, vfcs }, ref) => {
  useImperativeHandle(ref, () => ({
    validate: () => {
      const { nameOfDistrict, year, nameOfProjectVillage } =
        formData.formatI || {};
      return !!(nameOfDistrict && year && nameOfProjectVillage);
    },
  }));
  const handleChange = (field, value) => {
    setFormData({
      ...formData,
      formatI: { ...formData.formatI, [field]: value },
    });
  };

  const generateYearRanges = (startYear, endYear) => {
    const ranges = [];
    for (let year = startYear; year < endYear; year++) {
      ranges.push(`${year}-${year + 1}`);
    }
    return ranges;
  };

  const yearRanges = generateYearRanges(1999, new Date().getFullYear());
  return (
    <div>
      <Form.Group className="mb-3">
        <Form.Label>District Name</Form.Label>
        <Form.Control
          placeholder="District Name"
          onChange={(e) => handleChange("nameOfDistrict", e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Year</Form.Label>
        <Form.Control
          as="select"
          placeholder="Year"
          onChange={(e) => handleChange("year", e.target.value)}
        >
          <option value="">Select Year</option>
          {yearRanges.map((yr) => (
            <option key={yr} value={yr}>
              {yr}
            </option>
          ))}
        </Form.Control>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Project Village</Form.Label>
        <Form.Select
          onChange={(e) => handleChange("nameOfProjectVillage", e.target.value)}
        >
          <option value="">Select VFC</option>
          {vfcs.map((vfc) => (
            <option key={vfc._id} value={vfc._id}>
              {vfc.vfcName}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>
  );
});

export default FormatIForm;
